import type { CategoryTemplate } from '../types'

interface Props {
  category: CategoryTemplate
  open: boolean
  onOpenChange: (open: boolean) => void
  compact?: boolean
}

export default function AuditorPrompts({
  category,
  open,
  onOpenChange,
  compact = false,
}: Props) {
  return (
    <section
      className={`guidance-card auditor-prompts ${compact ? 'auditor-prompts--compact' : ''}`}
    >
      <button
        type="button"
        className="auditor-prompts__toggle"
        aria-expanded={open}
        onClick={() => onOpenChange(!open)}
      >
        <span className="auditor-prompts__title">
          <span aria-hidden="true">◎</span>
          <span>
            <strong>Auditor prompts</strong>
            <small>{category.prompts.length} reminders for {category.label.toLowerCase()}</small>
          </span>
        </span>
        <span className="status-pill">{open ? 'Hide' : 'Show guidance'}</span>
      </button>
      {open && (
        <div className="auditor-prompts__body">
          <p className="auditor-prompts__intro">
            Use these as thinking prompts, not required checks. Record only what you inspect, establish or need to follow up.
          </p>
          <ol className="auditor-prompt-list">
            {category.prompts.map((item, index) => (
              <li key={item.id}>
                <span>{index + 1}</span>
                <p>{item.label}</p>
              </li>
            ))}
          </ol>
          <div className="capture-cues">
            <strong>Capture if available</strong>
            <div>
              {category.dataPrompts.map((item) => <span key={item}>{item}</span>)}
            </div>
          </div>
          <p className="evidence-cue">
            <strong>Equipment tip:</strong> take a context photo and a readable nameplate photo, then note the actual setting,
            operating pattern and who confirmed it.
          </p>
          {category.safetyNote && (
            <p className="safety-note"><strong>Safety:</strong> {category.safetyNote}</p>
          )}
        </div>
      )}
    </section>
  )
}
